/**
 * Pannello storico notifiche in-app (user_notifications) + link bacheca.
 */
import {
  apiListNotifications,
  apiMarkNotificationRead,
  apiDismissNotification,
} from '../api.js';

function escapeHtml(text) {
  return String(text || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
}

function fmtTs(iso) {
  const s = String(iso || '').replace('Z', '').slice(0, 19);
  if (s.length >= 16 && s[10] === 'T') return `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)} ${s.slice(11, 16)}`;
  return s || '—';
}

export function openNotificationsPanel({ onChanged, highlightId } = {}) {
  const existing = document.getElementById('turni-notifications-overlay');
  if (existing) existing.remove();

  const overlay = document.createElement('div');
  overlay.id = 'turni-notifications-overlay';
  overlay.className = 'modal-overlay';
  overlay.innerHTML = `
    <div class="modal" role="dialog" aria-modal="true" style="max-width:640px; max-height:90vh; display:flex; flex-direction:column;">
      <div class="modal-header" style="display:flex; justify-content:space-between; align-items:center; gap:0.5rem;">
        <strong>Notifiche</strong>
        <div style="display:flex; gap:0.35rem;">
          <button type="button" class="btn btn-outline btn-sm" id="notif-open-bacheca">Apri bacheca</button>
          <button type="button" class="btn btn-secondary btn-sm" id="notif-close" aria-label="Chiudi">✕</button>
        </div>
      </div>
      <div class="modal-body" id="notif-body" style="overflow:auto; flex:1; min-height:200px;">
        <p class="text-secondary" style="margin:0;">Caricamento…</p>
      </div>
    </div>
  `;

  const close = () => {
    overlay.remove();
    if (typeof onChanged === 'function') onChanged();
  };

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });
  overlay.querySelector('#notif-close')?.addEventListener('click', close);
  overlay.querySelector('#notif-open-bacheca')?.addEventListener('click', () => {
    try {
      const u = new URL(window.location.href);
      u.searchParams.set('view', 'bacheca');
      u.searchParams.delete('notifications');
      u.searchParams.delete('nid');
      window.location.href = u.toString();
    } catch (_) {
      window.location.reload();
    }
  });

  document.body.appendChild(overlay);

  const bodyEl = overlay.querySelector('#notif-body');

  const renderItems = (items) => {
    if (!items.length) {
      bodyEl.innerHTML = '<p class="text-secondary" style="margin:0;">Nessuna notifica.</p>';
      return;
    }
    bodyEl.innerHTML = items
      .map((it) => {
        const id = escapeHtml(it.id);
        const unread = !it.read_at;
        const hi = highlightId && String(highlightId) === String(it.id) ? ' style="outline:2px solid var(--accent);"' : '';
        return `
          <article class="card" data-nid="${id}"${hi} style="margin-bottom:0.65rem; text-align:left;">
            <div style="display:flex; justify-content:space-between; gap:0.5rem; align-items:flex-start;">
              <div style="flex:1; min-width:0;">
                <div style="font-weight:600;">${escapeHtml(it.title)}</div>
                <div class="text-secondary" style="font-size:0.8rem;">${fmtTs(it.created_at)} · ${escapeHtml(it.type || '')}</div>
                <div style="margin-top:0.45rem; white-space:pre-wrap; font-size:0.92rem;">${escapeHtml(it.body)}</div>
              </div>
              <div style="display:flex; flex-direction:column; gap:0.25rem;">
                ${unread ? `<button type="button" class="btn btn-outline btn-sm" data-action="read" data-id="${id}">Letto</button>` : ''}
                <button type="button" class="btn btn-outline btn-sm" data-action="dismiss" data-id="${id}">Elimina</button>
              </div>
            </div>
          </article>
        `;
      })
      .join('');

    bodyEl.querySelectorAll('button[data-action]').forEach((btn) => {
      btn.addEventListener('click', async (ev) => {
        const id = ev.currentTarget.getAttribute('data-id');
        const action = ev.currentTarget.getAttribute('data-action');
        if (!id) return;
        try {
          if (action === 'read') await apiMarkNotificationRead(id);
          if (action === 'dismiss') await apiDismissNotification(id);
          await load();
          if (typeof onChanged === 'function') onChanged();
        } catch (err) {
          window.__showError?.(err?.message || String(err));
        }
      });
    });
  };

  async function load() {
    try {
      const data = await apiListNotifications({ limit: 50 });
      const items = Array.isArray(data?.items) ? data.items : [];
      renderItems(items);
    } catch (err) {
      bodyEl.innerHTML = `<p class="text-danger" style="margin:0;">${escapeHtml(err?.message || 'Errore caricamento')}</p>`;
    }
  }

  void load();
}
